<template>
  <div>
   <big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></big-img>
    <!-- <van-field v-model="detailData.position" label="部位" />
        <van-field v-model="detailData.part" label="部件" /> -->
    <!-- <van-field
            v-model="detailData.position"
            readonly
            :show-error="true"
            name="部位"
            label="部位"
            placeholder="部位"

            @click="$route.path =='/QualityCheckDetail'?showpositions = true:showpositions = false" />
        <van-popup
            v-model="showpositions"
            position="bottom">
            <van-picker
                item-height="1.173rem"
                show-toolbar
                :columns="positions"
                @cancel="showpositions = false"
                @confirm="confirmposition" />
        </van-popup>
        <van-field
            v-model="detailData.part"
            readonly
            :show-error="true"
            name="部件"
            label="部件"
            placeholder="部件"
            @click="bwpart" />
        <van-popup
            v-model="showpart"
            position="bottom">
            <van-picker
                item-height="1.173rem"
                show-toolbar
                :columns="parts"
                @cancel="showpart = false"
                @confirm="confirmpart" />
        </van-popup> -->
    <!-- <van-field
            v-model="detailData.maintenTypeName"
            :readonly="projectreadonly"
            autocomplete="off"
            :show-error="true"
            name="maintenTypeName"
            label="维修类型"
            placeholder="选择维修类型"
            @click="!projectreadonly ? showmaintainItemse = true : showmaintainItemse==false"
            />
        <van-popup
            v-model="showmaintainItemse"
            :style="{ height: '35%' }"
            position="bottom">
            <van-picker
                item-height="1.173rem"
                show-toolbar
                :columns="maintenTypes"
                @cancel="showpart = false"
                @confirm="maintenTypeNamese" />
        </van-popup> -->
        <van-field v-model="detailData.maintenTypeName" label="维修类型" required readonly />
        <van-field v-if="parentType !== 'quality'" v-model="detailData.maintainItem" label="维修项目" readonly />
        <van-field
            v-else
            v-model="detailData.maintainItem"
            autocomplete="off"
            :required="true"
            :show-error="true"
            :readonly="isReadOnly"
            name="maintainItem"
            label="维修项目"
            placeholder="选择项目"
            :rules="[ { required: true, message: '必填' } ]"
            @click="!isReadOnly?showmaintainItems = true:showmaintainItems = false"
            @input="queryMaintainItem"
            @blur="blurMaintainItem(detailData.maintainItem)" />
        <van-popup
            v-model="showmaintainItems"
            position="bottom">
            <van-picker
                item-height="1.173rem"
                show-toolbar
                :columns="maintainItemslist"
                @cancel="showmaintainItems = false"
                @confirm="confirmmaintainItem" />
        </van-popup>
        <van-field
            v-model="detailData.maintainType"
            autocomplete="off"
            readonly
            :show-error="true"
            :required="true"
            :rules="[{ required: true, message: '必填' }]"
            name="maintainType"
            label="项目分类"
            placeholder="自动带出"
        />
        <!-- <van-field
            v-model="detailData.maintainItemNum"
            autocomplete="off"
            :show-error="true"
            name="maintainItemNum"
            label="数量"
            placeholder="数量"
            @input="detailData.maintainItemNum= checkNumberFloat(detailData.maintainItemNum)" /> -->
    <van-row>
      <van-col class="num">数量</van-col>
      <van-col
        ><van-stepper
          v-model="detailData.maintainItemNum"
          class="num-stepper"
          min="1"
          max="99"
          integer
      /></van-col>
    </van-row>
    <van-field
      v-if="form.isNotMaintain"
      v-model="detailData.workHour"
      label="工时"
      readonly
    />
    <van-field v-else v-model="detailData.workHour" label="工时" required />
    <van-field
      v-if="
        (detailData.maintainItemId === '' ||
          detailData.maintainItemId == null) &&
        !form.isNotMaintain
      "
      v-model="detailData.unitPrice"
      label="工时单价"
      required
    />
    <van-field
      v-else
      v-model="detailData.unitPrice"
      label="工时单价"
      required
      readonly
    />
    <van-field v-model="detailData.teamName" label="维修队" required readonly />
    <div
      v-for="(item, index) of returnData.workerList"
      v-if="parentType == 'quality'"
      :key="index"
    >
      <van-row>
        <!-- <van-col :span="11">
                    <van-field
                        v-model="item.workerName"
                        label="维修工"
                        :border="true"
                        placeholder="请输入" @click="getWorkers(index)" />
                    <van-popup
                        v-model="showWorkers"
                        :style="{ height: '30%' }"
                        position="bottom">
                        <van-picker
                            item-height="1.173rem"
                            show-toolbar
                            :columns="workers"
                            @cancel="showWorkers = false"
                            @confirm="onWorkerConfirm" />
                    </van-popup>
                </van-col> -->
        <van-col :span="24">
          <!-- <van-field
                        v-model="detailData.stationName"
                        label="工位"
                        name='stationName'
                        :border="true"
                        placeholder="请输入"
                        @click="worklist" />
                    <van-popup
                        v-model="showworkse"
                        :style="{ height: '30%' }"
                        position="bottom">
                        <van-picker
                            item-height="1.173rem"
                            show-toolbar
                            :columns="workerNamese"
                            @cancel="showworkse = false"
                            @confirm="worker" />
                    </van-popup> -->
          <van-field
            v-model="detailData.stationName"
            label="工位"
            required
            readonly
          />
        </van-col>
        <!-- <van-col :span="11">
                    <van-field
                        v-model="item.percent"
                        label="占比"
                        :border="true"
                        placeholder="请输入" />
                </van-col>
                 
                <van-col :span="1" class="icon-style">
                    <van-icon name="plus" @click="addWorkOrder" />
                </van-col> -->
        <van-col :span="1" @click="deltWorkOrder(index)">
          <div style="font-size: 20px; margin-top: 10px">
            {{ item.deltBtn }}
          </div>
        </van-col>
      </van-row>
    </div>
    <div
      v-for="(item, index) of returnData.workerList"
      v-if="stateType == 'settle'"
      :key="index"
    >
      <van-row>
        <!-- <van-col :span="11">
                    <van-field
                        v-model="item.workerName"
                        label="维修工"
                        readonly
                        :border="true"
                        placeholder="请输入" @click="getWorkers(index)" />
                    <van-popup
                        v-model="showWorkers"
                        :style="{ height: '30%' }"
                        position="bottom">
                        <van-picker
                            item-height="1.173rem"
                            show-toolbar
                            :columns="workers"
                            @cancel="showWorkers = false"
                            @confirm="onWorkerConfirm" />
                    </van-popup>
                </van-col>
                <van-col :span="11">
                    <van-field
                        v-model="item.percent"
                        label="占比"
                        readonly
                        :border="true"
                        placeholder="请输入" />
                </van-col> -->
        <van-col :span="24">
          <van-field
            v-model="detailData.stationName"
            readonly
            label="工位"
            name="stationName"
            :border="true"
            placeholder="请输入"
            @click="worklist"
          />
          <!-- <van-popup
            v-model="showworkse"
            :style="{ height: '30%' }"
            position="bottom"
          >
            <van-picker
              item-height="1.173rem"
              show-toolbar
              :columns="workerNamese"
              @cancel="showworkse = false"
              @confirm="worker"
            />
          </van-popup> -->
        </van-col>
        <van-col :span="1" @click="deltWorkOrder(index)">
          <div style="font-size: 20px; margin-top: 10px">
            {{ item.deltBtn }}
          </div>
        </van-col>
      </van-row>
    </div>
    <van-field
      v-if="isStatement"
      v-model="returnData.qualityInspectionResultText"
      label="质检结果"
      placeholder="点击质检结果"
      clickable
      required
      readonly
    />
    <van-field
      v-else
      v-model="returnData.qualityInspectionResultText"
      label="质检结果"
      placeholder="点击质检结果"
      clickable
      required
      readonly
      @click="showQualityInspectionResult = true"
    />
    <van-popup v-model="showQualityInspectionResult" position="bottom">
      <van-picker
        item-height="1.173rem"
        show-toolbar
        value-key="text"
        :columns="enumQualityInspectionResults"
        @cancel="showQualityInspectionResult = false"
        @confirm="onQualityInspectionResultConfirm"
      />
    </van-popup>
    <van-field
      v-if="returnData.qualityInspectionResultText === '质检不通过'"
      v-model="returnData.qualityNotReason"
      label="质检不通过原因"
      required
    />
    <van-field
      v-if="itemDetailWrokType === 2"
      v-model="returnData.faultReasonText"
      label="故障原因"
      placeholder="点击故障原因"
      clickable
      required
      readonly
    />
    <van-field
      v-else-if="isStatement"
      v-model="returnData.faultReasonText"
      label="故障原因"
      placeholder="点击故障原因"
      clickable
      required
      readonly
    />
    <van-field
      v-else
      v-model="returnData.faultReasonText"
      label="故障原因"
      placeholder="点击故障原因"
      required
      readonly
      @click="showFaultReason = true"
    />
    <van-popup v-model="showFaultReason" position="bottom">
      <van-picker
        item-height="1.173rem"
        show-toolbar
        value-key="text"
        :columns="enumFaultReasons"
        @cancel="showFaultReason = false"
        @confirm="onFaultReasonConfirm"
      />
    </van-popup>
    <van-field
      v-model="detailData.remark"
      readonly
      disabled
      label="备注"
      name="stationName"
      :border="true"
      placeholder="请输入"
    />
   
    <van-field
      v-model="detailData.totalPrice"
      label="合计金额"
      required
      readonly
      class="moneyColor"
    />
    <div style="display:flex">
    <div class="container">
      <div class="Uploader"  v-if='detailData.faultPhoto'>
        <div class="image">故障点照片</div>
        <div class="imgAdd">
          <!-- <span class="itemImg">
            <img
              :src="detailData.faultPhoto"
              alt="图片"
              class="uploadimg"
              @click.stop="clickImg($event)"
            />
          </span> -->
          <span
            v-for="(item, index) in detailData.faultPhoto.split(';')"
            :key="index"
            class="itemImg" >
            <img :src="item" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
          </span>
        </div>
      </div>
      <div class="Uploader"  v-if='detailData.oldNewPhoto'>
        <div class="image">新旧件对比</div>
        <div class="imgAdd">
          <!-- <span class="itemImg">
            <img
              :src="detailData.oldNewPhoto"
              alt="图片"
              class="uploadimg"
              @click.stop="clickImg($event)"
            />
          </span> -->
          <span
            v-for="(item, index) in detailData.oldNewPhoto.split(';')"
            :key="index"
            class="itemImg">
            <img :src="item" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
        </span>
        </div>
      </div>
      <div class="Uploader"  v-if='detailData.faultOver'>
        <div class="image">故障完成</div>
        <div class="imgAdd">
          <!-- <span class="itemImg">
            <img
              :src="detailData.faultOver"
              alt="图片"
              class="uploadimg"
              @click.stop="clickImg($event)"
            />
          </span> -->
          <span
            v-for="(item, index) in detailData.faultOver.split(';')"
            :key="index"
            class="itemImg">
            <img :src="item" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
        </span>
        </div>
      </div>
    </div>
    </div>
    <van-button
      v-if="!form.isOnlyRequisitionPart"
      round
      block
      type="info"
      size="large"
      class="nextSpan"
      @click="$emit('onSaveDetailClick', returnData)"
      >保存</van-button
    >
  </div>
</template>
<script>
import {
  GetworkerByMtId,
  getMaintenitemlistForDropdw,
  queryhours,
  getDictionarySelect,
  getVehiclepositList,
  stationList,
} from '@/api/basics'
import BigImg from '../views/maintain/components/bigImg.vue'

export default {
    components:{
      BigImg  
    },
  name: 'MaintainItemDetail',
  props: {
    detailData: {
      type: Object,
      default: null,
    },
    itemDetailWrokType: {
      type: Number,
      default: 0,
    },
    isStatement: {
      type: Boolean,
      default: false,
    },
    parentType: {
      type: String,
      default: '',
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    formItem: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: null,
    },
    form: {
      type: Object,
      default: () => {
        return {}
      },
    },
    stateType: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
        showImg:false,
      imgSrc: '',
      maintenTypes: [],
      showworkse: false,
      showmaintainItemse: false,
      workerNamese: [],
      returnData: {
        workerNamese: [],
        position: null,
        qualityInspectionResultVal: 0,
        qualityInspectionResultText: '',
        faultReasonVal: 0,
        faultReasonText: '',
        workerList: [
          { workerName: '', workerId: '', percent: '', deltBtn: '' },
        ],
        maintainItemNum: null,
        workHour: 0,
        unitPrice: 0,
        totalPrice: 0,
        maintainItem: '',
        maintainItemId: '',
        qualityNotReason: '',
      },
      projectreadonly: false,
      showpositions: false,
      positions: [],
      parts: [],
      enumQualityInspectionResults: [
        { text: '未质检', value: 1 },
        { text: '质检通过', value: 2 },
        { text: '质检不通过', value: 3 },
        { text: '客户终止', value: 4 },
        { text: '不需维修', value: 5 },
        { text: '缺件', value: 6 },
      ],
      enumFaultReasons: [
        { text: '自然损坏', value: 1 },
        { text: '驾驶操作', value: 2 },
        { text: '配件质量', value: 3 },
        { text: '维修装配', value: 4 },
      ],
      showQualityInspectionResult: false,
      showFaultReason: false,
      showWorkers: false,
      showpart: false,
      // 维修工下拉
      workers: [],
      workerIndex: '',
      maintainItemslist: [],
      showmaintainItems: false,
      isReadOnly: false,
    }
  },
  watch: {
    'detailData.maintainItemNum'(val) {
      if (!val || val == 0) {
        // this.returnData.unitPrice = ''
        if (!val) {
          this.returnData.maintainItemNum = ''
        } else {
          this.returnData.maintainItemNum = 0
        }
        this.detailData.totalPrice = (
          Number(this.detailData.unitPrice) * Number(this.detailData.workHour)
        ).toFixed(2)
        this.returnData.totalPrice = (
          Number(this.detailData.unitPrice) * Number(this.detailData.workHour)
        ).toFixed(2)
      } else {
        this.returnData.maintainItemNum = val
        this.detailData.totalPrice = (
          Number(val) *
          this.detailData.workHour *
          this.detailData.unitPrice
        ).toFixed(2)
        this.returnData.totalPrice = this.detailData.totalPrice
      }
    },
    'detailData.unitPrice'(val) {
      if (!val || val == 0) {
        // this.returnData.unitPrice = ''
        if (!val) {
          this.returnData.unitPrice = ''
        } else {
          this.returnData.unitPrice = 0
        }
        this.detailData.totalPrice = Number(0).toFixed(2)
        this.returnData.totalPrice = 0
      } else if (
        !this.detailData.maintainItemNum ||
        this.detailData.maintainItemNum == 0
      ) {
        this.returnData.unitPrice = val
        this.detailData.totalPrice = (
          Number(val) * this.detailData.workHour
        ).toFixed(2)
        this.returnData.totalPrice = this.detailData.totalPrice
      } else {
        this.returnData.unitPrice = val
        this.detailData.totalPrice = (
          Number(val) *
          this.detailData.workHour *
          Number(this.detailData.maintainItemNum)
        ).toFixed(2)
        this.returnData.totalPrice = this.detailData.totalPrice
      }
    },
    'detailData.workHour'(val) {
      if (!val || val == 0) {
        //
        if (!val) {
          this.returnData.workHour =0
        } else {
          this.returnData.workHour = 0
        }
        this.detailData.totalPrice = Number(0).toFixed(2)
        this.returnData.totalPrice = 0
      } else if (
        !this.detailData.maintainItemNum ||
        this.detailData.maintainItemNum == 0
      ) {
        this.returnData.workHour = val
        this.detailData.totalPrice = (
          Number(val) * this.detailData.unitPrice
        ).toFixed(2)
        this.returnData.totalPrice = this.detailData.totalPrice
      } else {
        this.returnData.workHour = val
        this.detailData.totalPrice = (
          Number(val) *
          this.detailData.unitPrice *
          Number(this.detailData.maintainItemNum)
        ).toFixed(2)
        this.returnData.totalPrice = this.detailData.totalPrice
      }
    },
    'detailData.maintainItem'(val) {
      this.returnData.maintainItem = val
      this.returnData.maintainItemId = val
    },
    // 'detailData.maintainItemId'(val) {
    //     this.returnData.maintainItemId = val
    // },
    'formItem.maintainItem'(val) {
      val ? (this.isReadOnly = true) : (this.isReadOnly = false)
    },
  },
  created() {
    console.log(this.$route.path)
    // console.log(this.form.isNotMaintain)
    this.initReturnData()
    // 维修部位
    getDictionarySelect({ Code: 'Maintain:PositionsType' }).then((res) => {
      if (res.code === 200) {
        this.positions = res.data
        res.data.forEach((item) => {
          item.text = item.name
        })
        this.positions = res.data
      }
    })
    // 获取维修类型
    getDictionarySelect({ Code: 'Maintain:MaintenceType' }).then((res) => {
      if (res.isSuccess) {
        console.log(res.data)
        this.maintenTypes = res.data
        this.maintenTypes.forEach((item) => {
          item.text = item.name
        })
      }
    })
    // console.log('结算', this.isStatement)
    // console.log('返修', this.itemDetailWrokType)
    if (this.$route.name == 'QualityCheckDetail') {
      getMaintenitemlistForDropdw({ ModelIdStr: this.form.modelId }).then(
        (res) => {
          console.log(res)
          res.data.pagerData.forEach((item) => {
            item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
          })
          this.maintainItemslist = res.data.pagerData
          this.maintainItemslistCopy = JSON.parse(
            JSON.stringify(res.data.pagerData)
          )
        }
      )
    }
  },
  methods: {
    clickImg(e) {
      this.showImg = true
      // 获取当前图片地址
        this.imgSrc = e.currentTarget.src
      
    },
    viewImg() {
      console.log(1111)
      this.showImg = false
    },
    // 工位档案列表
    worklist() {
      stationList({
        StationCode: '',
        StationName: null,
        Status: null,
        CreatorName: '',
        StartDate: '',
        EndDate: '',
      }).then((res) => {
        this.workerNamese = res.data.pagerData
        this.workerNamese.forEach((item) => {
          item.text = item.stationName
        })
        this.showworkse = true
      })
    },
    //工位确认
    worker(val) {
      console.log(val)
      this.workerNamese.forEach((res) => {
        if (res.id == val.id) {
          this.detailData.stationName = res.text
          this.showworkse = false
        }
      })
    },
    // 部件列表
    bwpart() {
      if (this.$route.path == '/QualityCheckDetail') {
        // 部件列表
        getVehiclepositList({
          positionsName: [this.detailData.position],
          partName: '',
          startTime: '',
          endTime: '',
          PageSize: 10000,
          PageIndex: 1,
          allData: 2,
        }).then((res) => {
          if (res.data) {
            res.data.pagerData.forEach((item) => {
              item.text = item.partName
            })
            this.parts = res.data.pagerData
            this.showpart = true
          } else {
            this.parts = []
            this.showpart = false
          }
        })
      } else {
        this.showpart = false
      }
    },
    // 确认部件
    confirmpart(val) {
      this.parts.forEach((res) => {
        if (res.id == val.id) {
          this.detailData.part = res.partName
          this.detailData.partId = res.id
          this.returnData.part = res.partName
          this.returnData.partId = res.id
          this.showpart = false
        }
      })
    },
    // 确认维修类型
    maintenTypeNamese(val) {
      console.log(val, 'jrr')
      this.maintenTypes.forEach(async (res) => {
        if (res.id == val.id) {
          this.detailData.maintenTypeName = res.name
          this.detailData.maintenTypeId = res.code
          this.showmaintainItemse = false
          this.detailData.factor = res.factor
          this.detailData.code = res.code
        }
      })
    },
    // 确认部位
    // confirmposition(val) {
    //     this.positions.forEach(res => {
    //         if (res.id == val.id) {
    //             this.detailData.position = res.name
    //             this.returnData.position = res.name
    //             this.detailData.part = ''
    //             this.detailData.partId = ''
    //             this.returnData.part = ''
    //             this.returnData.partId = ''
    //             this.showpositions = false
    //         }
    //     })
    // },
    initReturnData() {
      console.log('主表', this.form)
      if (this.formItem.maintainItem) {
        this.isReadOnly = true
      }
      console.log(this.isReadOnly)
      this.returnData.workerList =
        this.detailData.workOrderMen || this.detailData.statementMen
      if (this.returnData.workerList.length <= 0) {
        this.returnData.workerList.push({
          workerName: '',
          workerId: '',
          percent: '',
          deltBtn: '',
        })
      }

      this.enumQualityInspectionResults.forEach((res) => {
        if (res.value == this.detailData.enumQualityInspectionResult) {
          this.returnData.qualityInspectionResultVal = res.value
          this.returnData.qualityInspectionResultText = res.text
        }
      })
      this.enumFaultReasons.forEach((res) => {
        if (res.value == this.detailData.enumFaultReason) {
          this.returnData.faultReasonVal = res.value
          this.returnData.faultReasonText = res.text
        }
      })
      this.returnData.qualityNotReason = this.detailData.qualityNotReason
      this.returnData.maintainItemNum = this.detailData.maintainItemNum
      this.returnData.workHour = this.detailData.workHour
      this.returnData.unitPrice = this.detailData.unitPrice
      this.returnData.position = this.detailData.position
      this.returnData.part = this.detailData.part
      this.returnData.partId = this.detailData.partId
      this.returnData.maintainItem = this.detailData.maintainItem
      this.returnData.maintainItemId = this.detailData.maintainItemId
      console.log('路径', this.$route.name)
      if (this.$route.name == 'QualityCheckDetail') {
        getMaintenitemlistForDropdw({ ModelIdStr: this.form.modelId }).then(
          (res) => {
            console.log(res)
            res.data.pagerData.forEach((item) => {
              item.text =
                item.code + '-' + item.name + '-' + item.maintenTypeName
            })
            this.maintainItemslist = res.data.pagerData
            this.maintainItemslistCopy = JSON.parse(
              JSON.stringify(res.data.pagerData)
            )
          }
        )
      }
    },
    orderMenSplit(items) {
      if (items !== null) {
        return items
          .map((item) => {
            return item.workerName
          })
          .join(',')
      } else {
        return ''
      }
    },
    onQualityInspectionResultConfirm(val) {
      this.enumQualityInspectionResults.forEach((res) => {
        if (res.text == val.text) {
          this.returnData.qualityInspectionResultVal = res.value
          this.returnData.qualityInspectionResultText = res.text

          this.showQualityInspectionResult = false
        }
      })
      console.log(val)
      if (val.value !== 3) {
        this.returnData.qualityNotReason = null
        this.detailData.qualityNotReason = null
      }
    },
    onFaultReasonConfirm(val) {
      this.enumFaultReasons.forEach((res) => {
        if (res.text == val.text) {
          this.returnData.faultReasonVal = res.value
          this.returnData.faultReasonText = res.text

          this.showFaultReason = false

                    // const faultReasonData = {
                    //     text: val.text,
                    //     value: val.value,
                    //     maintainItemId: this.detailData.maintainItemId,
                    //     partId: this.detailData.partId
                    // }
                    // this.$emit('onFaultReasonChange', faultReasonData)
                    this.detailData.text = val.text
                    this.detailData.enumFaultReason = val.value
                    this.$emit('onFaultReasonChange', this.detailData)
                }
            })
        },
        // 获取维修工
        async getWorkers(val) {
            console.log(val)
            this.workerIndex = val
            const res = await GetworkerByMtId({ MaintenanceTeamID: this.detailData.teamId })
            if (res.isSuccess) {
                res.data && res.data.forEach(item => {
                    item.text = item.workerName
                })
            }
            this.workers = res.data
            if (this.parentType == 'quality') {
                this.showWorkers = true
            } else {
                this.showWorkers = false
            }
        },
        // 点击维修工加号
        addWorkOrder() {
            this.returnData.workerList.push({ workerName: '', workerId: '', percent: '', deltBtn: '-' })
        },
        // 点击减号删除
        deltWorkOrder(index) {
            this.returnData.workerList.splice(index, 1)
        },
        onWorkerConfirm(val) {
            const { text, id } = val
            this.returnData.workerList[this.workerIndex].workerName = text
            this.returnData.workerList[this.workerIndex].workerId = id
            if (this.returnData.workerList.length == 1) {
                this.returnData.workerList[0].percent = 100
            }
            this.showWorkers = false
        },
        clearData() {
            this.returnData.faultReasonVal = 0
            this.returnData.faultReasonText = ''
            this.returnData.workerList = []
            this.returnData.qualityInspectionResultVal = 0
            this.returnData.qualityInspectionResultText = ''
        },
        // 维修项目模糊搜索
        async queryMaintainItem() {
            if (this.detailData.maintainItem) {
                const res = await getMaintenitemlistForDropdw({ 'keywords': this.detailData.maintainItem, ModelIdStr: this.form.modelId, 'beginDate': '', 'endDate': '', 'maintenTypeIds': [], 'PageSize': 20, 'PageIndex': 1 })
                res.data.pagerData.forEach(item => {
                    item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                })
                var authorityadmin = res.data.pagerData.filter(itmer => itmer.text.indexOf(this.detailData.maintainItem) === -1)
                if (authorityadmin.length == 0) {
                    this.maintainItemslist = res.data.pagerData
                    // this.maintainItemslistCopy = JSON.parse(JSON.stringify(res.data.pagerData || []))
                }
                // this.maintainItemslist = res.data.pagerData
            } else {
                const res = await getMaintenitemlistForDropdw({ 'keywords': '', ModelIdStr: this.form.modelId, 'beginDate': '', 'endDate': '', 'maintenTypeIds': [], 'PageSize': 20, 'PageIndex': 1 })
                res.data.pagerData.forEach(item => {
                    item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                })
                this.maintainItemslist = res.data.pagerData
            }
            console.log('维修项目', this.maintainItemslist.length)
            if (this.maintainItemslist.length == 0) {
                this.detailData.maintainItemId = null
                this.detailData.workHour = 0
                this.detailData.unitPrice = null
                this.detailData.maintainItemNum = null
            }
        },
        // 维修项目失焦
        blurMaintainItem(val) {
            let arr = []
            if (!this.isReadOnly && val) {
                arr = this.maintainItemslistCopy.filter(item => { return item.name == val })
                console.log('ddddddd', arr)
                if (arr.length == 0) {
                    this.detailData.maintainItem = null
                    this.returnData.maintainItem = null
                    this.returnData.maintainItemId = null
                    this.returnData.workHour = 0
                    this.returnData.unitPrice = null
                    this.returnData.maintainItemNum = null
                }
            }
        },
        // 确认维修项目
        confirmmaintainItem(val) {
            console.log(val)
            this.detailData.maintainType = val.maintainType
            this.maintainItemslist.forEach(async res => {
                if (res.id == val.id) {
                    this.detailData.enumMaintenType = res.enumMaintenType
                    this.detailData.maintainItem = res.code + '-' + res.name + '-' + res.maintenTypeName
                    this.detailData.maintainItemId = res.id
                    this.returnData.maintainItem = res.name
                    this.detailData.maintainType = res.maintainType
                    this.returnData.maintainItemId = res.id
                    this.showmaintainItems = false
                    this.detailData.workHour = res.hours
                    this.detailData.unitPrice = res.price
                    this.returnData.workHour = res.hours
                    this.returnData.unitPrice = res.price
                    // await queryhours({ maintenItemId: res.id, modelId: this.formData.modelId || this.formData.machineModelId }).then(res => {
                    //     if (res.data) {
                    //         this.detailData.workHour = res.data.hours
                    //         this.detailData.unitPrice = res.data.price
                    //         this.returnData.workHour = res.data.hours
                    //         this.returnData.unitPrice = res.data.price
                    //     } else {
                    //         this.detailData.workHour = null
                    //         this.detailData.unitPrice = null
                    //     }
                    //     this.detailData.maintainItemNum = null
                    // })
                }
            })
            // if (val) {
            //     this.projectreadonly = true
            //     // this.unitpricereadonly = true
            // } else {
            //     this.projectreadonly = false
            //     // this.unitpricereadonly = false
            // }
        }
    },
    // 获取维修工
    async getWorkers(val) {
      console.log(val)
      this.workerIndex = val
      const res = await GetworkerByMtId({
        MaintenanceTeamID: this.detailData.teamId,
      })
      if (res.isSuccess) {
        res.data &&
          res.data.forEach((item) => {
            item.text = item.workerName
          })
      }
      this.workers = res.data
      if (this.parentType == 'quality') {
        this.showWorkers = true
      } else {
        this.showWorkers = false
      }
    },
    // 点击维修工加号
    addWorkOrder() {
      this.returnData.workerList.push({
        workerName: '',
        workerId: '',
        percent: '',
        deltBtn: '-',
      })
    },
    // 点击减号删除
    deltWorkOrder(index) {
      this.returnData.workerList.splice(index, 1)
    },
    onWorkerConfirm(val) {
      const { text, id } = val
      this.returnData.workerList[this.workerIndex].workerName = text
      this.returnData.workerList[this.workerIndex].workerId = id
      if (this.returnData.workerList.length == 1) {
        this.returnData.workerList[0].percent = 100
      }
      this.showWorkers = false
    },
    clearData() {
      this.returnData.faultReasonVal = 0
      this.returnData.faultReasonText = ''
      this.returnData.workerList = []
      this.returnData.qualityInspectionResultVal = 0
      this.returnData.qualityInspectionResultText = ''
    },
    // 维修项目模糊搜索
    async queryMaintainItem() {
      if (this.detailData.maintainItem) {
        const res = await getMaintenitemlistForDropdw({
          keywords: this.detailData.maintainItem,
          ModelIdStr: this.form.modelId,
          beginDate: '',
          endDate: '',
          maintenTypeIds: [],
          PageSize: 20,
          PageIndex: 1,
        })
        res.data.pagerData.forEach((item) => {
          item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
        })
        var authorityadmin = res.data.pagerData.filter(
          (itmer) => itmer.text.indexOf(this.detailData.maintainItem) === -1
        )
        if (authorityadmin.length == 0) {
          this.maintainItemslist = res.data.pagerData
          // this.maintainItemslistCopy = JSON.parse(JSON.stringify(res.data.pagerData || []))
        }
        // this.maintainItemslist = res.data.pagerData
      } else {
        const res = await getMaintenitemlistForDropdw({
          keywords: '',
          ModelIdStr: this.form.modelId,
          beginDate: '',
          endDate: '',
          maintenTypeIds: [],
          PageSize: 20,
          PageIndex: 1,
        })
        res.data.pagerData.forEach((item) => {
          item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
        })
        this.maintainItemslist = res.data.pagerData
      }
      console.log('维修项目', this.maintainItemslist.length)
      if (this.maintainItemslist.length == 0) {
        this.detailData.maintainItemId = null
        this.detailData.workHour = 0
        this.detailData.unitPrice = null
        this.detailData.maintainItemNum = null
      }
    },
    // 维修项目失焦
    blurMaintainItem(val) {
      let arr = []
      if (!this.isReadOnly && val) {
        arr = this.maintainItemslistCopy.filter((item) => {
          return item.name == val
        })
        console.log('ddddddd', arr)
        if (arr.length == 0) {
          this.detailData.maintainItem = null
          this.returnData.maintainItem = null
          this.returnData.maintainItemId = null
          this.returnData.workHour = 0
          this.returnData.unitPrice = null
          this.returnData.maintainItemNum = null
        }
      }
    },
    // 确认维修项目
    confirmmaintainItem(val) {
      console.log(val)
      this.maintainItemslist.forEach(async (res) => {
        if (res.id == val.id) {
          this.detailData.enumMaintenType = res.enumMaintenType
          this.detailData.maintainItem =
            res.code + '-' + res.name + '-' + res.maintenTypeName
          this.detailData.maintainItemId = res.id
          this.returnData.maintainItem = res.name
          this.returnData.maintainItemId = res.id
          this.showmaintainItems = false
          this.detailData.workHour = res.hours
          this.detailData.unitPrice = res.price
          this.returnData.workHour = res.hours
          this.returnData.unitPrice = res.price
          // await queryhours({ maintenItemId: res.id, modelId: this.formData.modelId || this.formData.machineModelId }).then(res => {
          //     if (res.data) {
          //         this.detailData.workHour = res.data.hours
          //         this.detailData.unitPrice = res.data.price
          //         this.returnData.workHour = res.data.hours
          //         this.returnData.unitPrice = res.data.price
          //     } else {
          //         this.detailData.workHour = null
          //         this.detailData.unitPrice = null
          //     }
          //     this.detailData.maintainItemNum = null
          // })
        }
      })
      // if (val) {
      //     this.projectreadonly = true
      //     // this.unitpricereadonly = true
      // } else {
      //     this.projectreadonly = false
      //     // this.unitpricereadonly = false
      // }
  },
}
</script>
<style lang="scss">
.icon-style .van-icon {
  margin-top: 25px;
}
</style>
